import {createSelector} from 'reselect'
import get from "lodash/get"
import {getTrending} from "./trending"
import filter from 'lodash/filter'
import first from 'lodash/first'
import keys from 'lodash/keys'
import indexOf from 'lodash/indexOf'
import {genderItems, genderLabels} from "../utils/gender"
import {BASE_URL} from '../config'
import theme from '../styles/theme'

export const getGlobalContent = (state) => state.content.global
export const getIconicUrl = (state) => get(state.content.global, ['iconic_url']);
export const getSiteUrl = (state) => get(state.content.global, ['site_url']);
export const isUsingUniversalMenu = (state) => get(state.content.global, ['navigation_menu']) === 'Iconic Navigation Menu';
export const getCategories = (state) => state.content.global.categories;
export const getCurrentPageContent = (state) => state.content.page
export const getSiteTitle = (state) => state.content.global && state.content.global.site_title
export const getCurrentPath = (state) => state.location.pathname;
export const getPageType = (state) => get(state.content, ['page', 'type']);
export const getPageId = (state) => get(state.content, ['page', 'id']);
export const getCurrentLocation = (state) => state.location;
export const getArticlesContent = (state) => state.articles
export const getScreenWidth = (state) => state.content.screenWidth
export const getScreenBreakpoint = (state) => state.content.breakpoint
export const getSelectedGender = (state) => state.content.gender
export const getPreviewToken = (state) => state.content.previewToken;
export const getFlickityDragEndTime = (state) => state.content.flickityDragEndTime;

export const getExtraNavItems = (state) => get(state.content.global, ['universal_menu', 'extra_nav_items' ]);
export const getBottomNavItems = (state) => get(state.content.global, ['universal_menu', 'bottom_nav_items' ]);
export const getUniversalCategories = (state) => get(state.content.global, ['universal_menu', 'categories' ], []);

export const isCurrentBreakpointAtLeast = (state, breakpoint) => {
    const bpKeys = keys(theme.breakpoints);
    return bpKeys.indexOf(getScreenBreakpoint(state)) >= bpKeys.indexOf(breakpoint)
}

export const getCurrentPageTitle = createSelector(
    getCurrentPageContent,
    getSiteTitle,
    (page, siteTitle) => (page && page.title ? page.title : siteTitle)
)

export const getSelectedGenderLabel = createSelector(
    getSelectedGender,
    (gender) => !gender ? genderLabels[0] : genderLabels[indexOf( genderItems, gender ) || 0]
)

function transformOpenGraphImage(image) {
    if( ! get(image, "url")) return null
    return {
        url: image.url,
        width: image.dimensions.width,
        height: image.dimensions.height,
    }
}

function transformPageMetadata(page, global, path, title, siteTitle) {
    if( ! global ) return null;

    var metaTitle =  `${(get(page, ["meta", "meta_title"]) || title)}`;
    if( global.meta.meta_title !==  metaTitle) metaTitle += ` ${global.meta.meta_title}`;

    return {
        title: metaTitle,
        meta_title: metaTitle,
        metaDescription: get(page, ["meta", "meta_description"]) || global.meta.meta_description,
        metaKeywords: get(page, ["meta", "meta_keywords"]) || global.meta.meta_keywords,
        metaRobots: get(page, ["meta", "meta_robots"]) || global.meta.meta_robots || 'index,follow',
        ogUrl: global.site_url + path.replace(BASE_URL, ''), // strip the base url out because we are going to use the full url here
        ogTitle: get(page, ["meta", "open_graph_title"]) || metaTitle,
        ogDescription: get(page, ["meta", "open_graph_description"]) || global.meta.open_graph_description,
        ogImage: transformOpenGraphImage( get(page, ["meta", "open_graph_image"]) ) ||
                transformOpenGraphImage( global.meta.open_graph_image ),
        ogSiteName: siteTitle,
        ogType: page && (page.type === 'article' || page.type === 'lookbook') ? 'article' : 'website',
        ogPublishedDate: page && page.published_date
    }
}

export const getMetadata = createSelector(
    getCurrentPageContent,
    getGlobalContent,
    getCurrentPath,
    getCurrentPageTitle,
    getSiteTitle,
    transformPageMetadata
)


export const getIsTrending = createSelector(
    getTrending,
    getCurrentLocation,
    (trending, location) => {
        if( ! location ) return false;
        if(!trending || trending.length === 0 ) return false;
        return first(filter(trending, (trend) => location.pathname === trend.url)) && true;
    }
)


// WEBPACK FOOTER //
// ./src/selectors/content.js